export function tintColor(col, amt) {
  if (col.indexOf('#')==0) 
    col = col.substr(1);
  let colorval = parseInt(col, 16);

  let r = (colorval >> 16) & 0xff,
      g = (colorval >> 8) & 0xff,
      b = (colorval >> 0) & 0xff;
  
  r += amt; if (r > 0xff) r = 0xff; if (r < 0) r=0;
  g += amt; if (g > 0xff) g = 0xff; if (g < 0) g=0;
  b += amt; if (b > 0xff) b = 0xff; if (b < 0) b=0;
  
  col = r << 16 | g << 8 | b;
  
  return '#' + col.toString(16).padStart(6,'0');
}

export function hexToRgb(col) {
  if (col.indexOf('#')==0) 
    col = col.substr(1);
  let colorval = parseInt(col, 16);

  let r = (colorval >> 16) & 0xff,
      g = (colorval >> 8) & 0xff,
      b = (colorval >> 0) & 0xff;
 
  return {r, g, b};
}

export function objectIsEmpty(obj) {
  for (let x in obj) {
    if (Object.hasOwn(obj, x)) return false;
  }
  return true;
}